import { render, staticRenderFns } from "./ChangeRequestInsured.vue?vue&type=template&id=5bdbeed0"
import script from "./ChangeRequestInsured.vue?vue&type=script&lang=ts"
export * from "./ChangeRequestInsured.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports